import { cn } from "@/lib/utils";
import React, { useState, useEffect } from "react";

const categories = [
  { id: "599", label: "Under ₹599" },
  { id: "799", label: "Under ₹799" },
  { id: "999", label: "Under ₹999" },
  { id: "1499", label: "Under ₹1499" },
];

const BASE_URL =
  "https://sudathi.com/collections/saree?filter.v.price.gte=&sort_by=manual";

function PriceLevelColllection() {
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const lte = params.get("filter.v.price.lte");
    if (lte) {
      setActiveCategory(lte);
    }
  }, []);

  const handlePillClick = (id: string) => {
    setActiveCategory(id);
    const url = `${BASE_URL}&filter.v.price.lte=${id}`;
    window.location.href = url;
  };

  const pillItems = categories.map((cat) => ({
    ...cat,
    active: cat.id === activeCategory,
  }));

  return (
    <div className={cn("hp-w-full hp-overflow-hidden hp-mb-6")}>
      <div className="hp-flex hp-gap-2 swimlane2">
        {pillItems.map((item) => (
          <button
            key={item.id}
            className={cn(
              "hp-flex-shrink-0 hp-whitespace-nowrap hp-px-4 hp-py-3 hp-rounded-full hp-text-xl hp-font-medium hp-cursor-pointer hp-transition-colors",
              item.active
                ? "hp-bg-primary hp-text-white"
                : "hp-bg-secondary hp-text-secondary-foreground hp-hover:bg-secondary/80",
            )}
            onClick={() => handlePillClick(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default PriceLevelColllection;
